"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JackpotPrizeTierPrizeType = exports.GameVendor = exports.TopPrizeType = exports.IJackpotStatus = exports.IJackpotGameResultDataType = exports.GamesList = exports.GameActivationMethodState = exports.GameState = exports.GET_JACKPOT_GAMES = exports.DOWNLOAD_FILE = exports.ORDER_ITEMS = exports.INIT_FILTER = exports.GET_EXTERNAL_GAME_ID = exports.GET_SECONDCHANCE_ELIGIBLE_GAMES = exports.GET_SCRATCHERS_UNCLAIMED_PRIZES = exports.GET_UNCLAIMED_PRIZES_BY_GAME_ID = exports.GET_UNCLAIMED_PRIZES_BY_GAME_TYPES = exports.FETCH_LATEST_JACKPOT_RESULTS = exports.GET_NEXT_JACKPOT_RESULT = exports.GET_JACKPOT_RESULTS_FOR_GAME_FIRST_PAGE = exports.GET_JACKPOT_RESULTS_FOR_GAME = exports.GET_JACKPOT_PAYOUT_FOR_DRAWS = exports.SEND_PLAYERS_DATA_FOR_JACKPOT = exports.GET_LATEST_JACKPOT_RESULTS = exports.GET_LATEST_RESULTS_FOR_DRAW = exports.GET_NEXT_JACKPOT_RESULTS_FOR_DRAW = exports.GET_JACKPOT_RESULTS_FOR_DRAW = exports.RESET_GAME = exports.GET_GAME_CONFIG = exports.GET_GAMES_BY_IDS = exports.ALL_RELATED_GAMES = exports.RELATED_GAMES = exports.REPLACE_FILTER = exports.CLEAR_FILTER = exports.FETCH_GAME_META = exports.UPDATE_FILTER = exports.RESET_JACKPOT = exports.RESET_STATE = exports.GAME_ACTIVE_DRAWS = exports.GAME_DRAWS = exports.GAME_PRIZES = exports.GAME_BY_ID = exports.GET_FEATURED_GAME = exports.PUBLISHED_DRAW_GAMES = exports.PUBLISHED_GAMES = void 0;
const GamesList_1 = require("./GamesList");
Object.defineProperty(exports, "GamesList", { enumerable: true, get: function () { return GamesList_1.GamesList; } });
var IJackpotGameResultDataType;
(function (IJackpotGameResultDataType) {
    IJackpotGameResultDataType[IJackpotGameResultDataType["REGULAR"] = 0] = "REGULAR";
    IJackpotGameResultDataType[IJackpotGameResultDataType["HOT"] = 1] = "HOT";
    IJackpotGameResultDataType[IJackpotGameResultDataType["COLD"] = 2] = "COLD";
    IJackpotGameResultDataType[IJackpotGameResultDataType["SPECIAL"] = 3] = "SPECIAL";
    IJackpotGameResultDataType[IJackpotGameResultDataType["NORMAL"] = 4] = "NORMAL";
})(IJackpotGameResultDataType || (exports.IJackpotGameResultDataType = IJackpotGameResultDataType = {}));
var IJackpotStatus;
(function (IJackpotStatus) {
    IJackpotStatus[IJackpotStatus["OPEN"] = 0] = "OPEN";
    IJackpotStatus[IJackpotStatus["PAYABLE"] = 1] = "PAYABLE";
    IJackpotStatus[IJackpotStatus["COMPLETE"] = 2] = "COMPLETE";
})(IJackpotStatus || (exports.IJackpotStatus = IJackpotStatus = {}));
var JackpotPrizeTierPrizeType;
(function (JackpotPrizeTierPrizeType) {
    JackpotPrizeTierPrizeType["PARAMUTUEL"] = "PARAMUTUEL";
    JackpotPrizeTierPrizeType["FIXED"] = "FIXED";
})(JackpotPrizeTierPrizeType || (exports.JackpotPrizeTierPrizeType = JackpotPrizeTierPrizeType = {}));
var GameActivationMethodState;
(function (GameActivationMethodState) {
    GameActivationMethodState[GameActivationMethodState["DATA_SET_LEVEL"] = 0] = "DATA_SET_LEVEL";
    GameActivationMethodState[GameActivationMethodState["BOOK_LEVEL"] = 1] = "BOOK_LEVEL";
    GameActivationMethodState[GameActivationMethodState["TICKET_LEVEL"] = 2] = "TICKET_LEVEL";
})(GameActivationMethodState || (exports.GameActivationMethodState = GameActivationMethodState = {}));
var GameState;
(function (GameState) {
    GameState[GameState["DELETED"] = 0] = "DELETED";
    GameState[GameState["PUBLISHED"] = 1] = "PUBLISHED";
    GameState[GameState["DRAFT"] = 2] = "DRAFT";
})(GameState || (exports.GameState = GameState = {}));
var TopPrizeType;
(function (TopPrizeType) {
    TopPrizeType["PROGRESSIVE"] = "PROGRESSIVE";
    TopPrizeType["STATIC"] = "STATIC";
})(TopPrizeType || (exports.TopPrizeType = TopPrizeType = {}));
var GameVendor;
(function (GameVendor) {
    GameVendor["PBL"] = "PBL";
    GameVendor["SGI"] = "SGI";
    GameVendor["IGT"] = "IGT";
    GameVendor["NEOGAME"] = "NEOGAME";
    GameVendor["NGL"] = "NGL";
    GameVendor["NGLPBL"] = "NGLPBL";
})(GameVendor || (exports.GameVendor = GameVendor = {}));
const PUBLISHED_GAMES = 'games/PUBLISHED_GAMES';
exports.PUBLISHED_GAMES = PUBLISHED_GAMES;
const PUBLISHED_DRAW_GAMES = 'games/PUBLISHED_DRAW_GAMES';
exports.PUBLISHED_DRAW_GAMES = PUBLISHED_DRAW_GAMES;
const GET_FEATURED_GAME = 'games/GET_FEATURED_GAME';
exports.GET_FEATURED_GAME = GET_FEATURED_GAME;
const GAME_BY_ID = 'games/GAME_BY_ID';
exports.GAME_BY_ID = GAME_BY_ID;
const GAME_PRIZES = 'games/GAME_PRIZES';
exports.GAME_PRIZES = GAME_PRIZES;
const GAME_DRAWS = 'games/GAME_DRAWS';
exports.GAME_DRAWS = GAME_DRAWS;
const GAME_ACTIVE_DRAWS = 'games/GAME_ACTIVE_DRAWS';
exports.GAME_ACTIVE_DRAWS = GAME_ACTIVE_DRAWS;
const RESET_STATE = 'games/RESET_STATE';
exports.RESET_STATE = RESET_STATE;
const UPDATE_FILTER = 'games/UPDATE_FILTER';
exports.UPDATE_FILTER = UPDATE_FILTER;
const FETCH_GAME_META = 'games/FETCH_GAME_META';
exports.FETCH_GAME_META = FETCH_GAME_META;
const CLEAR_FILTER = 'games/CLEAR_FILTER';
exports.CLEAR_FILTER = CLEAR_FILTER;
const REPLACE_FILTER = 'games/REPLACE_FILTER';
exports.REPLACE_FILTER = REPLACE_FILTER;
const RELATED_GAMES = 'games/RELATED_GAMES';
exports.RELATED_GAMES = RELATED_GAMES;
const ALL_RELATED_GAMES = 'games/ALL_RELATED_GAMES';
exports.ALL_RELATED_GAMES = ALL_RELATED_GAMES;
const GET_GAMES_BY_IDS = 'games/GET_GAMES_BY_IDS';
exports.GET_GAMES_BY_IDS = GET_GAMES_BY_IDS;
const GET_GAME_CONFIG = 'games/GET_GAME_CONFIG';
exports.GET_GAME_CONFIG = GET_GAME_CONFIG;
const RESET_GAME = 'games/RESET_GAME';
exports.RESET_GAME = RESET_GAME;
const RESET_JACKPOT = 'games/RESET_JACKPOT';
exports.RESET_JACKPOT = RESET_JACKPOT;
const GET_LATEST_JACKPOT_RESULTS = 'games/GET_LATEST_JACKPOT_RESULTS';
exports.GET_LATEST_JACKPOT_RESULTS = GET_LATEST_JACKPOT_RESULTS;
const GET_JACKPOT_RESULTS_FOR_DRAW = 'games/GET_JACKPOT_RESULTS_FOR_DRAW';
exports.GET_JACKPOT_RESULTS_FOR_DRAW = GET_JACKPOT_RESULTS_FOR_DRAW;
const GET_NEXT_JACKPOT_RESULTS_FOR_DRAW = 'games/GET_NEXT_JACKPOT_RESULTS_FOR_DRAW';
exports.GET_NEXT_JACKPOT_RESULTS_FOR_DRAW = GET_NEXT_JACKPOT_RESULTS_FOR_DRAW;
const GET_LATEST_RESULTS_FOR_DRAW = 'games/GET_LATEST_RESULTS_FOR_DRAW';
exports.GET_LATEST_RESULTS_FOR_DRAW = GET_LATEST_RESULTS_FOR_DRAW;
const SEND_PLAYERS_DATA_FOR_JACKPOT = 'games/SEND_PLAYERS_DATA_FOR_JACKPOT';
exports.SEND_PLAYERS_DATA_FOR_JACKPOT = SEND_PLAYERS_DATA_FOR_JACKPOT;
const GET_JACKPOT_PAYOUT_FOR_DRAWS = 'games/GET_JACKPOT_PAYOUT_FOR_DRAWS';
exports.GET_JACKPOT_PAYOUT_FOR_DRAWS = GET_JACKPOT_PAYOUT_FOR_DRAWS;
const GET_NEXT_JACKPOT_RESULT = 'games/GET_NEXT_JACKPOT_RESULT';
exports.GET_NEXT_JACKPOT_RESULT = GET_NEXT_JACKPOT_RESULT;
const GET_JACKPOT_RESULTS_FOR_GAME = 'games/GET_JACKPOT_RESULTS_FOR_GAME';
exports.GET_JACKPOT_RESULTS_FOR_GAME = GET_JACKPOT_RESULTS_FOR_GAME;
const GET_JACKPOT_RESULTS_FOR_GAME_FIRST_PAGE = 'games/GET_JACKPOT_RESULTS_FOR_GAME_FIRST_PAGE';
exports.GET_JACKPOT_RESULTS_FOR_GAME_FIRST_PAGE = GET_JACKPOT_RESULTS_FOR_GAME_FIRST_PAGE;
const FETCH_LATEST_JACKPOT_RESULTS = 'games/FETCH_LATEST_JACKPOT_RESULTS';
exports.FETCH_LATEST_JACKPOT_RESULTS = FETCH_LATEST_JACKPOT_RESULTS;
const GET_UNCLAIMED_PRIZES_BY_GAME_TYPES = 'games/GET_UNCLAIMED_PRIZES_BY_GAME_TYPES';
exports.GET_UNCLAIMED_PRIZES_BY_GAME_TYPES = GET_UNCLAIMED_PRIZES_BY_GAME_TYPES;
const GET_UNCLAIMED_PRIZES_BY_GAME_ID = 'games/GET_UNCLAIMED_PRIZES_BY_GAME_ID';
exports.GET_UNCLAIMED_PRIZES_BY_GAME_ID = GET_UNCLAIMED_PRIZES_BY_GAME_ID;
const GET_SCRATCHERS_UNCLAIMED_PRIZES = 'games/GET_SCRATCHERS_UNCLAIMED_PRIZES';
exports.GET_SCRATCHERS_UNCLAIMED_PRIZES = GET_SCRATCHERS_UNCLAIMED_PRIZES;
const GET_SECONDCHANCE_ELIGIBLE_GAMES = 'games/GET_SECONDCHANCE_ELIGIBLE_GAMES';
exports.GET_SECONDCHANCE_ELIGIBLE_GAMES = GET_SECONDCHANCE_ELIGIBLE_GAMES;
const GET_EXTERNAL_GAME_ID = 'games/GET_EXTERNAL_GAME_ID';
exports.GET_EXTERNAL_GAME_ID = GET_EXTERNAL_GAME_ID;
const INIT_FILTER = 'games/INIT_FILTER';
exports.INIT_FILTER = INIT_FILTER;
const ORDER_ITEMS = 'games/ORDER_ITEMS';
exports.ORDER_ITEMS = ORDER_ITEMS;
const DOWNLOAD_FILE = 'games/DOWNLOAD_FILE';
exports.DOWNLOAD_FILE = DOWNLOAD_FILE;
const GET_JACKPOT_GAMES = 'games/GET_JACKPOT_GAMES';
exports.GET_JACKPOT_GAMES = GET_JACKPOT_GAMES;
//# sourceMappingURL=types.js.map